import { messaging, onMessage } from "../../../firebase";

export default {
  methods: {
    initializeAudio() {
      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        if (audioContext.state === "suspended") {
          audioContext.resume();
        }
        this.isAudioEnabled = true;
      } catch (error) {
        console.error("Error initializing audio:", error);
      }
    },
    listenForNotifications() {
      onMessage(messaging, (payload) => {
        this.playNotificationSound();

        const notificationFor = payload && payload.data && payload.data.notification_for;

        if (notificationFor === "food_order") {
          this.loadNavCounts();
          this.$router.push("/orders/today");
          this.makeToast("success", "New Food Order Received");
        } else if (notificationFor === "tablebooking") {
          this.loadNavCounts();
          this.$router.push("/business/reservations");
          this.makeToast("success", "New Table Booking Received");
        } else {
          this.makeToast("warning", "Notification received");
        }
      });
    },
    enableAudio() {
      this.isAudioEnabled = true;
      for (let i = 0; i < 3; i++) {
        setTimeout(() => {
          this.playAudio();
        }, i * 2000);
      }
    },
    playAudio() {
      const audio = new Audio(process.env.VUE_APP_API_BASE_URL + "beep.mp3");
      audio.play().catch((error) => {
        console.error("Error playing audio:", error);
      });
    },
    playNotificationSound() {
      try {
        const audioUrl = process.env.VUE_APP_API_BASE_URL + "beep.mp3";
        const localAudioUrl = "/beep.mp3";
        const audio = new Audio(audioUrl);
        audio.volume = 0.7;
        audio.preload = "auto";
        const playPromise = audio.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            this.playLocalSound(localAudioUrl);
          });
        }
      } catch (error) {
        console.error("Error creating audio object:", error);
        this.playFallbackSound();
      }
    },
    playLocalSound(audioUrl) {
      try {
        const audio = new Audio(audioUrl);
        audio.volume = 0.7;
        const playPromise = audio.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            this.playFallbackSound();
          });
        }
      } catch (error) {
        console.error("Error creating local audio object:", error);
        this.playFallbackSound();
      }
    },
    playFallbackSound() {
      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);
        oscillator.frequency.setValueAtTime(800, audioContext.currentTime);
        oscillator.type = "sine";
        gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.5);
      } catch (error) {
        console.error("Error playing fallback sound:", error);
      }
    },
  },
};
